/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import PropTypes from 'prop-types';

export const SearchProps = PropTypes.shape({
    loaded: PropTypes.bool,
    data: PropTypes.shape({
        results: PropTypes.arrayOf(
            PropTypes.shape({
                name: PropTypes.string,
            })
        ),
    }),
});
